<template>
	<div class="input-group input-group-birthday">
		<div class="input-group-prepend">
			<span class="input-group-text no-border-radius input-group-text-mobile" :class="[{'is-invalid': errorinfo.hasError}, {'disabled' : isProcessing}, inputclass]">
				Expiry <span class="input-mobile-border">&nbsp;</span></span>
		</div>
		<input class="form-control input-birthday no-border-radius" id="month-input" @input="onInput($event, 'month')" v-model="month" 
			type="number"
			placeholder="MM"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<input class="form-control input-birthday no-border-radius" id="year-input" @input="onInput($event, 'year')" v-model="year" 
			type="number" 
			placeholder="YYYY"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<small class="invalid-feedback" v-if="errorinfo.hasError">{{errorinfo.msg}}</small>
	</div>
</template>

<script>

export default {
	props: {
		value: {},
		placeholder: String,
		inputclass: String,
		isProcessing: Boolean,
		errorinfo: {type: Object, default: () => ({})}
	},
	mounted(){
		this.setInputFilter(document.getElementById("month-input"), function(value) { return /^\d*$/.test(value) });
		this.setInputFilter(document.getElementById("year-input"), function(value) { return /^\d*$/.test(value); });

		this.currentYear = new Date().getFullYear();
	},
	data: function() {
		return {
			in_expiry: {},
			month: undefined,
			year: undefined,
			currentYear: undefined,
		}
	},
	methods: {
		onInput(evt, field){
			
			if(field == 'month'){

				if(this.month.length > 2){
					this.month = this.month.substring(0,2);
				} else {
					this.in_expiry.month = this.month;
				}
			}

			if(field == 'year'){
				if(this.year.length > 4){
					this.year = this.year.substring(0,4);
				} else {
					this.in_expiry.year = this.year;
				}
			}

			this.in_expiry.isValid = true;
			if(this.in_expiry.month <= 0 || this.in_expiry.month > 12 || this.in_expiry.month == undefined){
				this.in_expiry.isValid = false;
				this.in_expiry.errorMsg = 'Month is invalid';
			} else if (this.in_expiry.year < this.currentYear || this.in_expiry.year == undefined){
				this.in_expiry.isValid = false;
				this.in_expiry.errorMsg = 'Year is invalid';
			}

			if(this.in_expiry.isValid){
				this.in_expiry.errorMsg = undefined;
			}
			
			this.$emit('input', this.in_expiry);
		},
		setInputFilter(textbox, inputFilter, maxLength) {
			["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
				textbox.addEventListener(event, function() {
				if (inputFilter(this.value)) {
					this.oldValue = this.value;
					this.oldSelectionStart = this.selectionStart;
					this.oldSelectionEnd = this.selectionEnd;
				} else if (this.hasOwnProperty("oldValue")) {
					this.value = this.oldValue;
					this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
				}
				});
			});
		}
		
		
	}
}
</script>